import React from 'react';
import { style } from 'typestyle';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { imgPath } from '~commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { doesTooltipNotHaveOwnerToDisplay } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { TooltipAnchor } from '~src/spacesPlatform/components/tooltip/TooltipAnchor';

import { Messages } from '../../../codegen/Localize';
import { DraftTags } from '../../../drafts/components/DraftTags';
import { ContentDraftStatus } from '../../../drafts/serverApi/types/ContentDraft';
import { DraftTagsParentType } from '../../../drafts/types/DraftsTypes';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { FlowBaseInfo } from '../../models/FlowInfo';
import { FlowTooltip } from '../tooltips/FlowTooltip';

const draftStatusWrapper = style({
  display: 'flex',
  marginBottom: CommonStyles.Sizes.SmallSpace,
});

export const FlowDefaultImageUrl = imgPath('spaces_masthead_flow.svg');

export class FlowCard extends ContentCard {

  private renderDraftStatus(flow: FlowBaseInfo) {
    return (
      <div className={draftStatusWrapper}>
        <DraftTags
          draftStatus={flow.draftStatus}
          parentType={DraftTagsParentType.card}
          explorableItemType={'flow'}
        />
      </div>
    );
  }
  public render() {
    const flow = this.props.content as FlowBaseInfo;
    const isUnpublishedFlowDraft = FeatureFlags.flowDraftsEnabled && flow.draftStatus === ContentDraftStatus.unpublished;
    const shouldShowFavoritesButton: boolean = this.showFavoritesStar() && !isUnpublishedFlowDraft;
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(flow);

    let navigateUrl = isUnpublishedFlowDraft ?
      this.props.urls.flowEditorDraftUrl(flow.draftLuid) :
      getContentUrlForItem(this.props.content, this.props.urls);

    if (isUnpublishedFlowDraft) {
      const server = getSessionManagementServiceInstance();
      if (flow.owner.id !== server.sessionUserId()) {
        navigateUrl = undefined;
      }
    }

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.flowTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail
            defaultImageUrl={FlowDefaultImageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={navigateUrl}
            useBase64EncodedImage={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
            openLinkInNewTab={isUnpublishedFlowDraft}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          {shouldShowFavoritesButton && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'flow' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'flow' })}
            />
          </span>}
          { this.renderActionsMenu() }
        </div>
        {FeatureFlags.flowDraftsEnabled && this.renderDraftStatus(flow)}
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <FlowTooltip
        content={this.props.content}
        urls={this.props.urls}
        inProjectSpace={this.props.inProjectSpace}
        inPersonalSpace={this.props.inPersonalSpace}
      />
    );
  };
}
